export default __webpack_public_path__ + "static/media/HyundaiBG.64f86b70.png";